import { getLabelFromGeo } from '@sbt-web/networking';

const getCityData = (entry) => {
    return {
        value: { entry, responseFrom: 'geogos', searchNearRegions: false },
        inputLabel: `${entry.city?.value} e provincia`,
        optionLabels: [entry.city?.value ?? '', 'e provincia'],
    };
};
const getRegionsData = (entry) => {
    return {
        value: { entry, responseFrom: 'geogos', searchNearRegions: true },
        inputLabel: `${entry.region?.value} e regioni vicine`,
        optionLabels: [entry.region?.value, 'e regioni vicine'],
    };
};
const getRegionData = (entry) => {
    return {
        value: { entry, responseFrom: 'geogos', searchNearRegions: false },
        inputLabel: entry.region?.value,
        optionLabels: [entry.region?.value, 'regione'],
    };
};
const translateGeogosResponse = (geogosResponse) => {
    const dataToAutocomplete = [];
    if (!geogosResponse?.entries?.length)
        return dataToAutocomplete;
    const { entries } = geogosResponse;
    for (let i = 0; i < entries.length; i++) {
        const entry = entries[i];
        if (entry.town) {
            dataToAutocomplete.push(getTownData(entry));
        }
        else if (entry.city) {
            dataToAutocomplete.push(getCityData(entry));
        }
        else {
            dataToAutocomplete.push(getRegionData(entries[i]), getRegionsData(entries[i]));
        }
    }
    return dataToAutocomplete;
};
const translateGeoEntry = (entry, searchNearRegions) => {
    const label = getLabelFromGeo(entry, searchNearRegions);
    return {
        optionLabels: [label],
        inputLabel: label,
        value: {
            entry,
            searchNearRegions: !!searchNearRegions,
            responseFrom: 'geogos',
        },
    };
};
const getTownData = (entry) => {
    return {
        value: { entry, responseFrom: 'geogos', searchNearRegions: false },
        inputLabel: `${entry.town?.value} (${entry.city?.shortName})`,
        optionLabels: [
            entry.town?.value ?? '',
            `(${entry.city?.shortName}) comune`,
        ],
    };
};

export { translateGeoEntry, translateGeogosResponse };
//# sourceMappingURL=GeogosToAutocomplete.js.map
